"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublishingStatusId = exports.getPublishingStatusName = exports.getLevelOfPlayId = exports.getLevelOfPlayName = exports.getGenderId = exports.getGenderName = exports.getProgramTypeId = exports.getProgramTypeName = exports.SKIP_EVENT_PRECREATION_PROGRAM_TYPES = exports.FOLDERED_REGISTRATION_PROGRAM_TYPES = exports.PROGRAM_TYPE_NAMES_MAPPER = exports.PROGRAM_TYPE_MAPPER = void 0;
const enums_service_1 = require("../../../services/enums.service");
const program_enums_1 = require("../enums/program.enums");
exports.PROGRAM_TYPE_MAPPER = {
    [program_enums_1.ProgramTypesEnum.CLASS]: program_enums_1.ProgramTypeNameEnum.CLASS,
    [program_enums_1.ProgramTypesEnum.CLINIC]: program_enums_1.ProgramTypeNameEnum.CLINIC,
    [program_enums_1.ProgramTypesEnum.CAMP]: program_enums_1.ProgramTypeNameEnum.CAMP,
    [program_enums_1.ProgramTypesEnum.CLUB_TEAM]: program_enums_1.ProgramTypeNameEnum.CLUB_TEAM,
    [program_enums_1.ProgramTypesEnum.LESSON]: program_enums_1.ProgramTypeNameEnum.LESSON,
    [program_enums_1.ProgramTypesEnum.TOURNAMENT]: program_enums_1.ProgramTypeNameEnum.TOURNAMENT,
    [program_enums_1.ProgramTypesEnum.LEAGUE]: program_enums_1.ProgramTypeNameEnum.LEAGUE,
    [program_enums_1.ProgramTypesEnum.LEAGUE_V2]: program_enums_1.ProgramTypeNameEnum.LEAGUE,
    [program_enums_1.ProgramTypesEnum.TOURNAMENT_V2]: program_enums_1.ProgramTypeNameEnum.TOURNAMENT,
};
exports.PROGRAM_TYPE_NAMES_MAPPER = {
    [program_enums_1.ProgramTypesEnum.CLASS]: program_enums_1.ProgramTypeNamesEnum.CLASS,
    [program_enums_1.ProgramTypesEnum.CLINIC]: program_enums_1.ProgramTypeNamesEnum.CLINIC,
    [program_enums_1.ProgramTypesEnum.CAMP]: program_enums_1.ProgramTypeNamesEnum.CAMP,
    [program_enums_1.ProgramTypesEnum.CLUB_TEAM]: program_enums_1.ProgramTypeNamesEnum.CLUB_TEAM,
    [program_enums_1.ProgramTypesEnum.LESSON]: program_enums_1.ProgramTypeNamesEnum.LESSON,
    [program_enums_1.ProgramTypesEnum.TOURNAMENT]: program_enums_1.ProgramTypeNamesEnum.TOURNAMENT,
    [program_enums_1.ProgramTypesEnum.LEAGUE]: program_enums_1.ProgramTypeNamesEnum.LEAGUE,
    [program_enums_1.ProgramTypesEnum.LEAGUE_V2]: program_enums_1.ProgramTypeNamesEnum.LEAGUE,
    [program_enums_1.ProgramTypesEnum.TOURNAMENT_V2]: program_enums_1.ProgramTypeNamesEnum.TOURNAMENT,
};
const PROGRAM_TYPE_ID_MAPPER = Object.fromEntries(Object.entries(exports.PROGRAM_TYPE_MAPPER).map(([id, name]) => [name, +id]));
const GENDER_MAPPER = {
    [enums_service_1.GenderEnum.OTHER]: enums_service_1.GenderNameEnum.EVERYONE,
    [enums_service_1.GenderEnum.MALE]: enums_service_1.GenderNameEnum.MALE,
    [enums_service_1.GenderEnum.FEMALE]: enums_service_1.GenderNameEnum.FEMALE,
};
const GENDER_ID_MAPPER = Object.fromEntries(Object.entries(GENDER_MAPPER).map(([id, name]) => [name, +id]));
const LEVEL_OF_PLAY_MAPPER = {
    [program_enums_1.LevelOfPlayEnum.BEGINNER]: program_enums_1.LevelOfPlayNameEnum.BEGINNER,
    [program_enums_1.LevelOfPlayEnum.INTERMEDIATE]: program_enums_1.LevelOfPlayNameEnum.INTERMEDIATE,
    [program_enums_1.LevelOfPlayEnum.ADVANCED]: program_enums_1.LevelOfPlayNameEnum.ADVANCED,
    [program_enums_1.LevelOfPlayEnum.SEMIPRO]: program_enums_1.LevelOfPlayNameEnum.SEMIPRO,
    [program_enums_1.LevelOfPlayEnum.SPECTATOR]: program_enums_1.LevelOfPlayNameEnum.SPECTATOR,
};
exports.FOLDERED_REGISTRATION_PROGRAM_TYPES = [program_enums_1.ProgramTypesEnum.LEAGUE_V2, program_enums_1.ProgramTypesEnum.TOURNAMENT_V2];
exports.SKIP_EVENT_PRECREATION_PROGRAM_TYPES = exports.FOLDERED_REGISTRATION_PROGRAM_TYPES;
const LEVEL_OF_PLAY_ID_MAPPER = Object.fromEntries(Object.entries(LEVEL_OF_PLAY_MAPPER).map(([id, name]) => [name, +id]));
const getProgramTypeName = (id) => exports.PROGRAM_TYPE_MAPPER[id];
exports.getProgramTypeName = getProgramTypeName;
const getProgramTypeId = (name) => name ? PROGRAM_TYPE_ID_MAPPER[name] ?? +name : undefined;
exports.getProgramTypeId = getProgramTypeId;
const getGenderName = (id) => GENDER_MAPPER[id];
exports.getGenderName = getGenderName;
const getGenderId = (name) => (name ? GENDER_ID_MAPPER[name] ?? +name : undefined);
exports.getGenderId = getGenderId;
const getLevelOfPlayName = (id) => LEVEL_OF_PLAY_MAPPER[id];
exports.getLevelOfPlayName = getLevelOfPlayName;
const getLevelOfPlayId = (name) => name ? LEVEL_OF_PLAY_ID_MAPPER[name] ?? +name : undefined;
exports.getLevelOfPlayId = getLevelOfPlayId;
const PUBLISHING_STATUS_MAPPER = {
    [program_enums_1.PublishingStatusEnum.DRAFT]: 'DRAFT',
    [program_enums_1.PublishingStatusEnum.PUBLISHED]: 'PUBLISHED',
    [program_enums_1.PublishingStatusEnum.CLOSED]: 'CLOSED',
    [program_enums_1.PublishingStatusEnum.CANCELLED]: 'CANCELLED',
    [program_enums_1.PublishingStatusEnum.ARCHIVE]: 'ARCHIVE',
    [program_enums_1.PublishingStatusEnum.UNPUBLISHED]: 'UNPUBLISHED',
};
const PUBLISHING_STATUS_ID_MAPPER = Object.fromEntries(Object.entries(PUBLISHING_STATUS_MAPPER).map(([id, name]) => [name, +id]));
const getPublishingStatusName = (id) => PUBLISHING_STATUS_MAPPER[id];
exports.getPublishingStatusName = getPublishingStatusName;
const getPublishingStatusId = (name) => name ? PUBLISHING_STATUS_ID_MAPPER[name] ?? +name : undefined;
exports.getPublishingStatusId = getPublishingStatusId;
//# sourceMappingURL=program.consts.js.map